import ms252 from "./ms-252";
import ms253 from "./ms-253";
import ms254 from "./ms-254";
import ms255 from "./ms-255";

export default { ms252, ms253, ms254, ms255 };
